// import MenuItem from "@mui/material/MenuItem";
// import Select from "@mui/material/Select";
// import { MdClose } from "react-icons/md";
// import tw from "tailwind-styled-components";
// import { Formik, Form } from "formik";
// import {
//     InputGroup,
//     Label,
//     SubmitBtn,
//     SideCancelBtn,
//     FieldWrappers,
// } from "../Styles/InputStyles";
// import { toast } from "react-toastify";
// import { ProfileSection } from "../Styles/PageStyles";
// import moment from "moment";
// import { useEffect, useState } from "react";
// import axios from "axios";
// import Config from "../../Config";
// import { useSelector } from "react-redux";
// import { capitalizeFirstLetter } from "../../helpers";
// import { Link } from "react-router-dom";
// import { FaPlus } from "react-icons/fa";
// import SelectOptionModal from "../SelectOptionModal";
// import { useMutation } from "react-query";
// import { TextareaAutosize } from "@mui/material";

// const ComplaintAction = ({
//     handleClose,
//     selectedData,
//     assignComplaintLoading,
//     assignComplaintMutate,
//     updateComplaintLoading,
//     updateComplaintMutate,
//     activeTab
// }) => {

//     const user = useSelector((state) => state.UserReducer.user);
//     const selProperty = useSelector((state) => state.SelectPropertyReducer.selectProperty);
//     const propId = selProperty.id;
//     const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
//     const [currentStatus, setCurrentStatus] = useState(selectedData?.status);
//     const [remarks, setRemarks] = useState(selectedData?.remarks || "");
//     const [showRemarkInput, setShowRemarkInput] = useState(false);
//     const [remarkText, setRemarkText] = useState("");
//     const [characterCount, setCharacterCount] = useState(0);

//     const initialValues = {
//         name: selectedData?.raisedByName || "",
//         propertyName: selectedData?.propertyName || "",
//         status: selectedData?.status || "",
//         assignedTo: "",
//         staffNote: selectedData?.staffNote
//     };

//     const getStatus = (status) => {
//         if (status === 1) {
//             return <Pending>Pending</Pending>;
//         } else if (status === 2) {
//             return <Completed>Assigned</Completed>;
//         } else if (status === 3) {
//             return <Active>Resolved</Active>;
//         } else {
//             return "Invalid Status";
//         }
//     };

//     const query = `?propId=${propId}&filter=${1}?s`;
//     const [selectedStatus, setSelectedStatus] = useState(
//         selectedData?.status || ""
//     );
//     const [staffData, setStaffData] = useState([]);

//     const fetchListing = async () => {
//         try {
//             const response = await axios.get(
//                 `${Config.apiUrl}/staff/list/web${query}`,
//                 {
//                     headers: {
//                         "Content-Type": "application/json",
//                         Authorization: `Bearer ${user.token}`,
//                     },
//                 }
//             );
//             setStaffData(response.data);
//         } catch (error) {
//             toast.error("Failed to fetch staff list");
//         }
//     };

//     useEffect(() => {
//         if (selectedStatus === 2) {
//             fetchListing();
//         }
//     }, [selectedStatus]);

//     const handleSubmit = (values, { resetForm }) => {
//         if (currentStatus === 1 && selectedStatus !== 2 && selectedStatus !== 3) {
//             toast.error("Please select a correct status value");
//             return;
//         }
//         if (currentStatus === 2 && selectedStatus !== 3) {
//             toast.error("Please select a correct status value");
//             return;
//         }
//         if (currentStatus === 1 && selectedStatus === 2) {
//             if (!values.assignedTo) {
//                 toast.error("Please select a staff to assign the complaint.");
//                 return;
//             }
//             assignComplaintMutate({
//                 staffId: values.assignedTo,
//                 complaintId: selectedData?.id,
//                 complaintFor: selectedData?.raisedFor,
//             });
//         }

//         if (selectedStatus === 3) {
//             updateComplaintMutate({
//                 status: selectedStatus,
//                 complaintId: selectedData?.id,
//                 complaintFor: selectedData?.raisedFor,
//             });
//         }

//         resetForm();
//     };

//     const staffOptions = staffData?.data?.map(staff => ({
//         label: staff.name,
//         value: staff.id,
//     })) || [];

//     const handleRemarkChange = (e) => {
//         const text = e.target.value;
//         if (text.length <= 500) {
//             setRemarkText(text);
//             setCharacterCount(text.length);
//         }
//     };

//     const handleRemarkSubmit = async () => {
//         if (!remarkText.trim()) {
//             toast.error("Please enter a remark");
//             return;
//         }
//         addNoteComplaintMutate({
//             id: selectedData?.id,
//             remarks: remarkText,
//         });

//     };

//     const handleCancelRemark = () => {
//         setRemarkText("");
//         setCharacterCount(0);
//         setShowRemarkInput(false);
//     };

//     //------- Add Note Complaint Model -------
//     const addNoteComplaintFunction = async (values) => {
//         return await axios.post(`${Config.apiUrl}/complaint/edit/staffNote`, values, {
//             headers: {
//                 "Content-Type": "application/json",
//                 authorization: `Bearer ${user.token}`,
//             },
//         });
//     };

//     const addNoteComplaintSuccess = (data) => {
//         // setIsAssignNoteOpen(false);
//         setRemarks(remarkText);
//         setRemarkText("");
//         setCharacterCount(0);
//         setShowRemarkInput(false);
//         toast.success(data?.data?.msg || "Remark added successfully!");
//     };

//     const addNoteComplaintError = (data) => {
//         toast.error(data?.response?.data?.msg || "An Error Occurred");
//     };

//     const { isLoading: addNoteComplaintLoading, mutate: addNoteComplaintMutate } =
//         useMutation(addNoteComplaintFunction, {
//             onSuccess: addNoteComplaintSuccess,
//             onError: addNoteComplaintError,
//         });


//     return (
//         <Container>
//             <Header>
//                 <Title>Complaint Details</Title>
//                 <button onClick={handleClose}>
//                     <MdClose color="white" size={24} />
//                 </button>
//             </Header>
//             <Formik
//                 initialValues={initialValues}
//                 onSubmit={handleSubmit}
//                 enableReinitialize
//             >
//                 {({ values, setFieldValue, resetForm }) => {
//                     const getSelectedStaffName = () => {
//                         const selectedStaff = staffData?.data?.find(staff => staff.id === values.assignedTo);
//                         return selectedStaff ? selectedStaff.name : "Select Staff";
//                     };

//                     const handleStaffSelect = (selectedValue) => {
//                         setFieldValue("assignedTo", selectedValue);
//                     };
//                     return (
//                         <Form>
//                             <ScrollableContent>
//                                 <ProfileSection>
//                                     <UserInfo>
//                                         <span className="font-medium">
//                                             {capitalizeFirstLetter(selectedData.raisedByName)}
//                                         </span>
//                                         {activeTab === "1" &&
//                                             <span className="text-sm text-gray-600">
//                                                 #{selectedData.roomNum},{" "}
//                                                 {selectedData.floor || selectedData.flatName},{" "}
//                                                 {selectedData.propertyName}
//                                             </span>}
//                                         {activeTab === "2" &&
//                                             <span className="text-sm text-gray-600">
//                                                 #{selectedData.propertyName}
//                                             </span>}
//                                     </UserInfo>
//                                 </ProfileSection>
//                                 <Content>
//                                     <ComplaintDetails>
//                                         <div className="flex justify-between items-center">
//                                             <SubTitle className="mb-0">{selectedData?.title}</SubTitle>
//                                             <EditButton
//                                                 title={(remarks || selectedData?.staffNote) && !showRemarkInput ? "Edit Remark" : "Add Remark"}
//                                                 type="button"
//                                                 onClick={() => setShowRemarkInput(!showRemarkInput)}
//                                             >
//                                                 {(remarks || selectedData?.staffNote) && !showRemarkInput ? "Edit Remark" : "Add Remark"}
//                                             </EditButton>
//                                         </div>
//                                         <InfoText>{selectedData?.description}</InfoText>
//                                     </ComplaintDetails>

//                                     {showRemarkInput && (
//                                         <div >
//                                             <Label>Add Remark *</Label>
//                                             <TextareaAutosize
//                                                 minRows={4}
//                                                 maxRows={6}
//                                                 value={remarkText}
//                                                 onChange={handleRemarkChange}
//                                                 placeholder="Enter your remark here (max 500 characters)"
//                                                 className="w-full p-3 border border-gray-300 rounded-md  resize-none mt-1"
//                                                 maxLength={500}
//                                             />
//                                             <div className="flex justify-between items-center mt-2">
//                                                 <span className={`text-sm ${characterCount === 500 ? 'text-red-500' : 'text-gray-500'}`}>
//                                                     {characterCount}/500 characters
//                                                 </span>
//                                                 <div className="flex gap-2">
//                                                     <button
//                                                         type="button"
//                                                         onClick={handleCancelRemark}
//                                                         className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
//                                                     >
//                                                         Cancel
//                                                     </button>
//                                                     <button
//                                                         type="button"
//                                                         onClick={handleRemarkSubmit}
//                                                         disabled={addNoteComplaintLoading || !remarkText.trim()}
//                                                         className={`px-4 py-2 text-sm font-medium text-white rounded-md  ${addNoteComplaintLoading || !remarkText.trim()
//                                                             ? 'bg-primary-color/50 cursor-not-allowed'
//                                                             : 'bg-primary-color'
//                                                             }`}
//                                                     >
//                                                         {addNoteComplaintLoading ? 'Submitting...' : 'Submit'}
//                                                     </button>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     )}

//                                     {(remarks || selectedData?.staffNote) && !showRemarkInput && (
//                                         <div >
//                                             <div className="flex justify-between items-center mb-1">
//                                                 <Label >Remark</Label>

//                                             </div>
//                                             <div className="bg-gray-50 px-4 py-2 rounded-md border border-gray-200">
//                                                 <InfoText>{remarks || selectedData?.staffNote}</InfoText>
//                                             </div>
//                                         </div>
//                                     )}

//                                     <Timeline>
//                                         <SubTitle>Complaint History</SubTitle>
//                                         <TimelineItem>
//                                             <TimelineDot />
//                                             <TimelineContent>
//                                                 <InfoText>
//                                                     Complaint raised by {selectedData.raisedByName} at{" "}
//                                                     {moment(selectedData?.createdAt).format(
//                                                         "DD-MMM-YYYY hh:mm A"
//                                                     )}
//                                                 </InfoText>
//                                             </TimelineContent>
//                                         </TimelineItem>
//                                         {selectedData?.status === 2 && <TimelineItem>
//                                             <TimelineDot />
//                                             <TimelineContent>
//                                                 <InfoText>
//                                                     Assigned to {selectedData.staffName} at{" "}
//                                                     {moment(selectedData?.updatedAt).format(
//                                                         "DD-MMM-YYYY hh:mm A"
//                                                     )}
//                                                 </InfoText>
//                                             </TimelineContent>
//                                         </TimelineItem>}
//                                         {selectedData?.resolvedAt &&
//                                             <TimelineItem>
//                                                 <TimelineDot />
//                                                 <TimelineContent>
//                                                     <InfoText>
//                                                         Complaint Resolved by {selectedData.staffName} At{" "}
//                                                         {moment(selectedData?.resolvedAt).format(
//                                                             "DD-MMM-YYYY hh:mm A"
//                                                         )}
//                                                     </InfoText>
//                                                 </TimelineContent>
//                                             </TimelineItem>}

//                                     </Timeline>
//                                     <SubTitle className="mb-0">
//                                         Current Status
//                                     </SubTitle>
//                                     {getStatus(selectedData?.status)}

//                                     {selectedData?.status != 3 && (
//                                         <InputGroup>
//                                             <Label>Status *</Label>
//                                             <Select
//                                                 value={selectedStatus}
//                                                 onChange={(e) => setSelectedStatus(e.target.value)}
//                                                 className="bg-white px-2 text-gray-600"
//                                                 style={{ height: "46px" }}
//                                             >
//                                                 {selectedData?.status == 1 && [
//                                                     <MenuItem key={1} value={1}>
//                                                         Pending
//                                                     </MenuItem>,
//                                                     <MenuItem key={2} value={2}>
//                                                         Assigned
//                                                     </MenuItem>,
//                                                     <MenuItem key={3} value={3}>
//                                                         Resolved
//                                                     </MenuItem>,
//                                                 ]}
//                                                 {selectedData?.status == 2 && [
//                                                     <MenuItem key={1} value={1}>
//                                                         Pending
//                                                     </MenuItem>,
//                                                     <MenuItem key={2} value={2}>
//                                                         Assigned
//                                                     </MenuItem>,
//                                                     <MenuItem key={3} value={3}>Resolved</MenuItem>
//                                                 ]}
//                                             </Select>
//                                         </InputGroup>
//                                     )}
//                                     {selectedData.status == 1 && selectedStatus == 2 && staffData?.data?.length > 0 && (
//                                         <InputGroup>
//                                             <Label>Assign To </Label>
//                                             <FieldWrappers onClick={() => setIsAssignModalOpen(true)}>
//                                                 <input
//                                                     type="text"
//                                                     name="assignedTo"
//                                                     autoComplete="off"
//                                                     readOnly
//                                                     value={getSelectedStaffName()}
//                                                     className="w-full border-none outline-none bg-transparent cursor-pointer text-gray-600"
//                                                 />
//                                                 <IconWrapper>
//                                                     <FaPlus className="w-3 h-3" />
//                                                 </IconWrapper>
//                                             </FieldWrappers>
//                                         </InputGroup>
//                                     )}

//                                     {selectedData?.img &&
//                                         <div className="flex justify-end">
//                                             <FlexCol>
//                                                 <Value className="text-blue-300 underline">
//                                                     <Link
//                                                         to={selectedData?.img}
//                                                         target="_blank"
//                                                         rel="noopener noreferrer"
//                                                     >
//                                                         {selectedData?.img?.split("/").pop()}
//                                                     </Link>
//                                                 </Value>
//                                             </FlexCol>
//                                         </div>
//                                     }
//                                 </Content>
//                             </ScrollableContent>
//                             {selectedData.status != 3 &&
//                                 <ActionSection>
//                                     <SideCancelBtn type="button" onClick={() => {
//                                         resetForm();
//                                         handleClose();
//                                     }}>
//                                         Cancel
//                                     </SideCancelBtn>
//                                     <SubmitBtn type="submit" disabled={assignComplaintLoading}>
//                                         {assignComplaintLoading ? "Loading..." : "Submit"}</SubmitBtn>
//                                 </ActionSection>}
//                             <SelectOptionModal
//                                 isOpen={isAssignModalOpen}
//                                 onClose={() => setIsAssignModalOpen(false)}
//                                 title="Select Staff"
//                                 options={staffOptions}
//                                 selectedValue={values.assignedTo}
//                                 onSelect={(selectedValue) => handleStaffSelect(selectedValue, setFieldValue)}
//                                 searchPlaceholder="Search staff..."
//                             />
//                         </Form>
//                     )
//                 }}
//             </Formik>
//         </Container>
//     );
// };

// // Styled components
// const Container = tw.div`bg-white w-full h-full flex flex-col relative`;
// const Header = tw.div`flex items-center justify-between bg-[#26A69A] py-4 px-4`;
// const Title = tw.h1`text-lg md:text-xl font-medium text-center text-white`;
// const ScrollableContent = tw.div`flex-grow overflow-y-auto max-h-[calc(100vh-140px)]`;
// const Content = tw.div`p-4 flex flex-col gap-4`;
// const SubTitle = tw.h3`text-base font-medium mb-2 text-gray-600`;
// const InfoText = tw.h3`text-sm text-gray-400 leading-relaxed break-words`;
// const UserInfo = tw.div`flex flex-col`;
// const ComplaintDetails = tw.div`flex flex-col gap-2`;
// const Timeline = tw.div`flex flex-col gap-2 mt-0`;
// const TimelineItem = tw.div`flex items-start gap-2`;
// const TimelineDot = tw.div`w-2 h-2 rounded-full bg-primary-color mt-2`;
// const TimelineContent = tw.div`flex flex-col`;
// const ActionSection = tw.div`p-4 bg-white flex justify-between border-t border-gray-200 absolute bottom-0 left-0 w-full`;
// const Active = tw.div`bg-green-100 text-green-700 text-xs border-green-300 border w-24 h-7 flex items-center justify-center rounded`;
// const Pending = tw.div`bg-blue-100 text-blue-700 text-xs border-blue-300 border w-24 h-7 flex items-center justify-center rounded`;
// const Completed = tw.div`bg-lime-100 text-lime-700 text-xs border-lime-300 border w-24 h-7 flex items-center justify-center rounded`;
// const FlexCol = tw.div`flex flex-col gap-0.5`;
// const Value = tw.span`text-gray-600 text-md`;
// const IconWrapper = tw.div`mr-2 flex-shrink-0 p-2 rounded-lg transition-all duration-300 bg-gray-100 text-gray-600`;
// const EditButton = tw.button` text-sm px-1 py-0.5 items-center flex justify-between text-primary-color underline`;
// export default ComplaintAction;

import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { MdClose } from "react-icons/md";
import tw from "tailwind-styled-components";
import { Formik, Form } from "formik";
import {
    InputGroup,
    Label,
    SubmitBtn,
    SideCancelBtn,
    FieldWrappers,
} from "../Styles/InputStyles";
import { toast } from "react-toastify";
import { ProfileSection } from "../Styles/PageStyles";
import moment from "moment";
import { useEffect, useState } from "react";
import axios from "axios";
import Config from "../../Config";
import { useSelector } from "react-redux";
import { capitalizeFirstLetter } from "../../helpers";
import { Link } from "react-router-dom";
import { FaPlus } from "react-icons/fa";
import SelectOptionModal from "../SelectOptionModal";
import { useMutation } from "react-query";
import { TextareaAutosize } from "@mui/material";

const ComplaintAction = ({
    handleClose,
    selectedData,
    assignComplaintLoading,
    assignComplaintMutate,
    updateComplaintLoading,
    updateComplaintMutate,
    activeTab
}) => {

    const user = useSelector((state) => state.UserReducer.user);
    const selProperty = useSelector((state) => state.SelectPropertyReducer.selectProperty);
    const propId = selProperty.id;
    const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
    const [currentStatus, setCurrentStatus] = useState(selectedData?.status);
    const [remarks, setRemarks] = useState(selectedData?.remarks || "");
    const [showRemarkInput, setShowRemarkInput] = useState(false);
    const [remarkText, setRemarkText] = useState("");
    const [characterCount, setCharacterCount] = useState(0);

    const initialValues = {
        name: selectedData?.raisedByName || "",
        propertyName: selectedData?.propertyName || "",
        status: selectedData?.status || "",
        assignedTo: selectedData?.assignedTo || "",
        staffNote: selectedData?.staffNote
    };

    const getStatus = (status) => {
        if (status === 1) {
            return <Pending>Pending</Pending>;
        } else if (status === 2) {
            return <Completed>Assigned</Completed>;
        } else if (status === 3) {
            return <Active>Resolved</Active>;
        } else {
            return "Invalid Status";
        }
    };

    const query = `?propId=${propId}&filter=${1}?s`;
    const [selectedStatus, setSelectedStatus] = useState(
        selectedData?.status || ""
    );
    const [staffData, setStaffData] = useState([]);

    const fetchListing = async () => {
        try {
            const response = await axios.get(
                `${Config.apiUrl}/staff/list/web${query}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${user.token}`,
                    },
                }
            );
            setStaffData(response.data);
        } catch (error) {
            toast.error("Failed to fetch staff list");
        }
    };

    useEffect(() => {
        if (selectedStatus === 2 || (selectedData?.status === 2 && selectedStatus === 2)) {
            fetchListing();
        }
    }, [selectedStatus]);

    const handleSubmit = (values, { resetForm }) => {
        if (currentStatus === 1 && selectedStatus !== 2 && selectedStatus !== 3) {
            toast.error("Please select a correct status value");
            return;
        }
        if (currentStatus === 2 && selectedStatus !== 3 && selectedStatus !== 2) {
            toast.error("Please select a correct status value");
            return;
        }

        if (selectedStatus === 2) {
            if (!values.assignedTo) {
                toast.error("Please select a staff to assign the complaint.");
                return;
            }

            assignComplaintMutate({
                staffId: values.assignedTo,
                complaintId: selectedData?.id,
                complaintFor: selectedData?.raisedFor,
                isReassignment: currentStatus === 2
            });
        } else if (selectedStatus === 3) {
            updateComplaintMutate({
                status: selectedStatus,
                complaintId: selectedData?.id,
                complaintFor: selectedData?.raisedFor,
            });
        } else if (selectedStatus === 1) {
            updateComplaintMutate({
                status: selectedStatus,
                complaintId: selectedData?.id,
                complaintFor: selectedData?.raisedFor,
                assignedTo: null
            });
        }

        resetForm();
    };

    const staffOptions = staffData?.data?.map(staff => ({
        label: staff.name,
        value: staff.id,
    })) || [];

    const handleRemarkChange = (e) => {
        const text = e.target.value;
        if (text.length <= 500) {
            setRemarkText(text);
            setCharacterCount(text.length);
        }
    };

    const handleRemarkSubmit = async () => {
        if (!remarkText.trim()) {
            toast.error("Please enter a remark");
            return;
        }
        addNoteComplaintMutate({
            id: selectedData?.id,
            remarks: remarkText,
        });

    };

    const handleCancelRemark = () => {
        setRemarkText("");
        setCharacterCount(0);
        setShowRemarkInput(false);
    };

    //------- Add Note Complaint Model -------
    const addNoteComplaintFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/complaint/edit/staffNote`, values, {
            headers: {
                "Content-Type": "application/json",
                authorization: `Bearer ${user.token}`,
            },
        });
    };

    const addNoteComplaintSuccess = (data) => {
        setRemarks(remarkText);
        setRemarkText("");
        setCharacterCount(0);
        setShowRemarkInput(false);
        toast.success(data?.data?.msg || "Remark added successfully!");
    };

    const addNoteComplaintError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occurred");
    };

    const { isLoading: addNoteComplaintLoading, mutate: addNoteComplaintMutate } =
        useMutation(addNoteComplaintFunction, {
            onSuccess: addNoteComplaintSuccess,
            onError: addNoteComplaintError,
        });


    return (
        <Container>
            <Header>
                <Title>Complaint Details</Title>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </Header>
            <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                enableReinitialize
            >
                {({ values, setFieldValue, resetForm }) => {
                    const getSelectedStaffName = () => {
                        if (selectedData?.assignedTo && !values.assignedTo) {
                            const assignedStaff = staffData?.data?.find(staff => staff.id === selectedData.assignedTo);
                            return assignedStaff ? `${assignedStaff.name} (Current)` : "Select Staff";
                        }

                        const selectedStaff = staffData?.data?.find(staff => staff.id === values.assignedTo);
                        return selectedStaff ? selectedStaff.name : "Select Staff";
                    };

                    const handleStaffSelect = (selectedValue) => {
                        setFieldValue("assignedTo", selectedValue);
                    };

                    return (
                        <Form>
                            <ScrollableContent>
                                <ProfileSection>
                                    <UserInfo>
                                        <span className="font-medium">
                                            {capitalizeFirstLetter(selectedData.raisedByName)}
                                        </span>
                                        {activeTab === "1" &&
                                            <span className="text-sm text-gray-600">
                                                #{selectedData.roomNum},{" "}
                                                {selectedData.floor || selectedData.flatName},{" "}
                                                {selectedData.propertyName}
                                            </span>}
                                        {activeTab === "2" &&
                                            <span className="text-sm text-gray-600">
                                                #{selectedData.propertyName}
                                            </span>}
                                    </UserInfo>
                                </ProfileSection>
                                <Content>
                                    <ComplaintDetails>
                                        <div className="flex justify-between items-center">
                                            <SubTitle className="mb-0">{selectedData?.title}</SubTitle>
                                            <EditButton
                                                title={(remarks || selectedData?.staffNote) && !showRemarkInput ? "Edit Remark" : "Add Remark"}
                                                type="button"
                                                onClick={() => setShowRemarkInput(!showRemarkInput)}
                                            >
                                                {(remarks || selectedData?.staffNote) && !showRemarkInput ? "Edit Remark" : "Add Remark"}
                                            </EditButton>
                                        </div>
                                        <InfoText>{selectedData?.description}</InfoText>
                                    </ComplaintDetails>

                                    {showRemarkInput && (
                                        <div >
                                            <Label>Add Remark *</Label>
                                            <TextareaAutosize
                                                minRows={4}
                                                maxRows={6}
                                                value={remarkText}
                                                onChange={handleRemarkChange}
                                                placeholder="Enter your remark here (max 500 characters)"
                                                className="w-full p-3 border border-gray-300 rounded-md  resize-none mt-1"
                                                maxLength={500}
                                            />
                                            <div className="flex justify-between items-center mt-2">
                                                <span className={`text-sm ${characterCount === 500 ? 'text-red-500' : 'text-gray-500'}`}>
                                                    {characterCount}/500 characters
                                                </span>
                                                <div className="flex gap-2">
                                                    <button
                                                        type="button"
                                                        onClick={handleCancelRemark}
                                                        className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                                                    >
                                                        Cancel
                                                    </button>
                                                    <button
                                                        type="button"
                                                        onClick={handleRemarkSubmit}
                                                        disabled={addNoteComplaintLoading || !remarkText.trim()}
                                                        className={`px-4 py-2 text-sm font-medium text-white rounded-md  ${addNoteComplaintLoading || !remarkText.trim()
                                                            ? 'bg-primary-color/50 cursor-not-allowed'
                                                            : 'bg-primary-color'
                                                            }`}
                                                    >
                                                        {addNoteComplaintLoading ? 'Submitting...' : 'Submit'}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {(remarks || selectedData?.staffNote) && !showRemarkInput && (
                                        <div >
                                            <div className="flex justify-between items-center mb-1">
                                                <Label >Remark</Label>

                                            </div>
                                            <div className="bg-gray-50 px-4 py-2 rounded-md border border-gray-200">
                                                <InfoText>{remarks || selectedData?.staffNote}</InfoText>
                                            </div>
                                        </div>
                                    )}

                                    <Timeline>
                                        <SubTitle>Complaint History</SubTitle>
                                        <TimelineItem>
                                            <TimelineDot />
                                            <TimelineContent>
                                                <InfoText>
                                                    Complaint raised by {selectedData.raisedByName} at{" "}
                                                    {moment(selectedData?.createdAt).format(
                                                        "DD-MMM-YYYY hh:mm A"
                                                    )}
                                                </InfoText>
                                            </TimelineContent>
                                        </TimelineItem>
                                        {selectedData?.status === 2 && <TimelineItem>
                                            <TimelineDot />
                                            <TimelineContent>
                                                <InfoText>
                                                    Assigned to {selectedData.staffName} at{" "}
                                                    {moment(selectedData?.updatedAt).format(
                                                        "DD-MMM-YYYY hh:mm A"
                                                    )}
                                                </InfoText>
                                            </TimelineContent>
                                        </TimelineItem>}
                                        {selectedData?.resolvedAt &&
                                            <TimelineItem>
                                                <TimelineDot />
                                                <TimelineContent>
                                                    <InfoText>
                                                        Complaint Resolved by {selectedData.staffName} At{" "}
                                                        {moment(selectedData?.resolvedAt).format(
                                                            "DD-MMM-YYYY hh:mm A"
                                                        )}
                                                    </InfoText>
                                                </TimelineContent>
                                            </TimelineItem>}

                                    </Timeline>
                                    <SubTitle className="mb-0">
                                        Current Status
                                    </SubTitle>
                                    {getStatus(selectedData?.status)}

                                    {selectedData?.status != 3 && (
                                        <InputGroup>
                                            <Label>Status *</Label>
                                            <Select
                                                value={selectedStatus}
                                                onChange={(e) => {
                                                    setSelectedStatus(e.target.value);
                                                    if (e.target.value !== 2) {
                                                        setFieldValue("assignedTo", "");
                                                    }
                                                }}
                                                className="bg-white px-2 text-gray-600"
                                                style={{ height: "46px" }}
                                            >
                                                {selectedData?.status == 1 && [
                                                    <MenuItem key={1} value={1}>
                                                        Pending
                                                    </MenuItem>,
                                                    <MenuItem key={2} value={2}>
                                                        Assigned
                                                    </MenuItem>,
                                                    <MenuItem key={3} value={3}>
                                                        Resolved
                                                    </MenuItem>,
                                                ]}
                                                {selectedData?.status == 2 && [
                                                    // <MenuItem key={1} value={1}>
                                                    //     Pending
                                                    // </MenuItem>,
                                                    <MenuItem key={2} value={2}>
                                                        Assigned
                                                    </MenuItem>,
                                                    <MenuItem key={3} value={3}>
                                                        Resolved
                                                    </MenuItem>
                                                ]}
                                            </Select>
                                        </InputGroup>
                                    )}


                                    {selectedStatus == 2 && staffData?.data?.length > 0 && (
                                        <InputGroup>
                                            <Label>{selectedData.status === 2 ? "Reassign To" : "Assign To"} *</Label>
                                            <FieldWrappers onClick={() => setIsAssignModalOpen(true)}>
                                                <input
                                                    type="text"
                                                    name="assignedTo"
                                                    autoComplete="off"
                                                    readOnly
                                                    value={getSelectedStaffName()}
                                                    className="w-full border-none outline-none bg-transparent cursor-pointer text-gray-600"
                                                    placeholder="Select staff"
                                                />
                                                <IconWrapper>
                                                    <FaPlus className="w-3 h-3" />
                                                </IconWrapper>
                                            </FieldWrappers>
                                            {selectedData.status === 2 && selectedData.assignedTo && (
                                                <p className="text-sm text-gray-500 mt-1">
                                                    Currently assigned to: {selectedData.staffName}
                                                </p>
                                            )}
                                        </InputGroup>
                                    )}

                                    {selectedData?.img &&
                                        <div className="flex justify-end">
                                            <FlexCol>
                                                <Value className="text-blue-300 underline">
                                                    <Link
                                                        to={selectedData?.img}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {selectedData?.img?.split("/").pop()}
                                                    </Link>
                                                </Value>
                                            </FlexCol>
                                        </div>
                                    }
                                </Content>
                            </ScrollableContent>
                            {selectedData.status != 3 &&
                                <ActionSection>
                                    <SideCancelBtn type="button" onClick={() => {
                                        resetForm();
                                        handleClose();
                                    }}>
                                        Cancel
                                    </SideCancelBtn>
                                    <SubmitBtn
                                        type="submit"
                                        disabled={assignComplaintLoading || updateComplaintLoading}
                                    >
                                        {assignComplaintLoading || updateComplaintLoading ?
                                            "Loading..." :
                                            selectedData.status === 2 && selectedStatus === 2 ?
                                                "Reassign" :
                                                "Submit"}
                                    </SubmitBtn>
                                </ActionSection>}
                            <SelectOptionModal
                                isOpen={isAssignModalOpen}
                                onClose={() => setIsAssignModalOpen(false)}
                                title={selectedData.status === 2 ? "Select New Staff" : "Select Staff"}
                                options={staffOptions}
                                selectedValue={values.assignedTo}
                                onSelect={(selectedValue) => handleStaffSelect(selectedValue, setFieldValue)}
                                searchPlaceholder="Search staff..."
                            />
                        </Form>
                    )
                }}
            </Formik>
        </Container>
    );
};

const Container = tw.div`bg-white w-full h-full flex flex-col relative`;
const Header = tw.div`flex items-center justify-between bg-[#26A69A] py-4 px-4`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-white`;
const ScrollableContent = tw.div`flex-grow overflow-y-auto max-h-[calc(100vh-140px)]`;
const Content = tw.div`p-4 flex flex-col gap-4`;
const SubTitle = tw.h3`text-base font-medium mb-2 text-gray-600`;
const InfoText = tw.h3`text-sm text-gray-400 leading-relaxed break-words`;
const UserInfo = tw.div`flex flex-col`;
const ComplaintDetails = tw.div`flex flex-col gap-2`;
const Timeline = tw.div`flex flex-col gap-2 mt-0`;
const TimelineItem = tw.div`flex items-start gap-2`;
const TimelineDot = tw.div`w-2 h-2 rounded-full bg-primary-color mt-2`;
const TimelineContent = tw.div`flex flex-col`;
const ActionSection = tw.div`p-4 bg-white flex justify-between border-t border-gray-200 absolute bottom-0 left-0 w-full`;
const Active = tw.div`bg-green-100 text-green-700 text-xs border-green-300 border w-24 h-7 flex items-center justify-center rounded`;
const Pending = tw.div`bg-blue-100 text-blue-700 text-xs border-blue-300 border w-24 h-7 flex items-center justify-center rounded`;
const Completed = tw.div`bg-lime-100 text-lime-700 text-xs border-lime-300 border w-24 h-7 flex items-center justify-center rounded`;
const FlexCol = tw.div`flex flex-col gap-0.5`;
const Value = tw.span`text-gray-600 text-md`;
const IconWrapper = tw.div`mr-2 flex-shrink-0 p-2 rounded-lg transition-all duration-300 bg-gray-100 text-gray-600`;
const EditButton = tw.button` text-sm px-1 py-0.5 items-center flex justify-between text-primary-color underline`;
export default ComplaintAction;